module.exports = __webpack_public_path__ + "static/media/(LH)-07-Capim-Dourado-bijuterias.47639dff.jpg";